import * as Config from '../config';
import { useState, useEffect, useContext } from "react";
import { ReactReduxContext } from 'react-redux';

let lockExtract = false;
const useExtract = (pathApi, params, exceptIds = []) => {
  const [data, setData] = useState(null);
  const { store } = useContext(ReactReduxContext)
  const api = store.getState().api;

  useEffect(() => {
    setData(null);
    lockExtract = false;
  }, [pathApi])

  useEffect(() => {
    if (api && !lockExtract) {

      lockExtract = true;
      const uniqueFilter = (v,i,a) => a.findIndex( t => (t.id === v.id) ) === i;
      const exceptFilter = (x) => !exceptIds.includes(x.id);
      let prepareData = [];

      api.getFromApi(pathApi).then( res => {
        const resData = res.data.results;
        prepareData = params.map( param => {
          let collect = [];
          resData.forEach( item => {
            param.props.forEach( prop => {
              const [first, second] =  prop.split(`|`);
              const itemProp = (second) ? item[first][second] : item[first];

              if (itemProp) {
                // console.log(item.name, itemProp, prop);
                if (Array.isArray(itemProp)) {
                  const newItems = itemProp.reduce( (base, x) => {
                    let y = collect.find( c => c.id === x.id );
                    if (y) {
                      y.vote += 1;
                    } else {
                      x.vote = 1;
                      base.push(x);
                    }
                    return base;
                  }, []);
                  collect = [...collect, ...newItems];
                } else {
                  const newItem = itemProp;
                  let y = collect.find( c => c.id === newItem.id );
                  if (y) {
                    y.vote += 1;
                  } else {
                    newItem.vote = 1;
                    collect.push(newItem);
                  }
                }
              }
            })
          })

          collect = collect.filter(uniqueFilter).filter(exceptFilter);
          collect = (param.format) ? collect.map(Config[param.format]) : collect;
          collect = (param.isRandom) ? Config.shuffle(collect) : collect;
          if (param.isRanked) {
            collect.sort(Config.sortNumeric(`vote`, false));
            collect = collect.map( (x, i) => { x.rank = i + 1; return x } );
          }
          collect = (param.limit) ? collect.splice(0, param.limit) : collect;
          // if (param.isRanked && param.limit) {
          //   collect = [ ...collect.filter( (x,i) => i % 2 === 0 ), ...collect.filter( (x,i) => i % 2 === 1 ) ]
          // }

          return { ...param, data: collect }
        } )

        setData(prepareData);

      }).catch( e => console.log(e) );
    }
  }, [api, pathApi, params, exceptIds])

  return data;
};

export default useExtract;
